module.exports = __webpack_public_path__ + "img/1.029e9c55.svg";